/* eslint-disable @typescript-eslint/no-explicit-any */
import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import React from 'react';
import { Link } from 'gatsby';
import ReactMarkdown from 'react-markdown';
import ContentfulProductReview from '../components/ContentfulProductReview';
import { customIdFromText } from './customIdFromJsx';
import { Heading2 } from '../components/common/Heading2';
import PageList from '../components/PageList';
import { renderAsset } from './renderAsset';
import SimpleTable from '../components/SimpleTable/SimpleTable';
import { OutboundLink } from '../components/common/OutboundLink';

const lang = 'nb-NO';

type customBlock = 'productReview2' | 'pageList' | 'produktTabell';

const renderEmbeddedEntry: React.FC<any> = (node) => {
  if (
    !node ||
    !node.data ||
    !node.data.target ||
    !node.data.target.sys ||
    !node.data.target.sys.contentType ||
    !node.data.target.sys.contentType.sys
  ) {
    return null;
  }
  const { id }: { id: customBlock } = node.data.target.sys.contentType.sys;
  switch (id) {
    case 'produktTabell': {
      const productTableFields = node.data.target.fields;
      const title = productTableFields.title[lang];
      const productReferences = productTableFields.productReferences[lang];
      const products = productReferences.map((productRef) => {
        const { fields } = productRef;
        const name = fields.name[lang];
        const productFields = fields.productImage[lang].fields;
        const productImage = {
          alt: productFields.description[lang],
          fileName: productFields.file[lang].fileName,
        };
        const url = fields.url[lang][0];

        return { name, productImage, url };
      });

      return (
        <>
          <Heading2 id={customIdFromText(title)}>{title}</Heading2>
          <SimpleTable products={products} />
        </>
      );
    }
    case 'pageList': {
      const refs = node.data.target.fields.pageListItemRefs[lang];
      const pages = refs.map(({ fields, sys }: { fields: any; sys: any }) => {
        const shortName = fields.shortName[lang];
        const slug = fields.pageReference[lang].fields.slug[lang];
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { updatedAt, contentful_id } = sys;
        return {
          shortName,
          slug,
          id: contentful_id,
          updatedAt,
        };
      });
      return <PageList pages={pages} />;
    }
    case 'productReview2': {
      const { fields } = node.data.target;
      const title = fields.title[lang];
      const mdReviewText = fields.reviewText[lang];
      const productFields = fields.product[lang].fields;
      const productName = productFields.name[lang];
      const productImageFields = productFields.productImage
        ? productFields.productImage[lang].fields
        : null;
      const productImage = {
        alt: productImageFields ? productImageFields.description[lang] : '',
        fileName: productImageFields && productImageFields.file[lang].fileName,
      };
      return (
        <ContentfulProductReview
          affiliateUrl={productFields.url[lang][0]}
          title={title}
          productImage={productImage}
          productName={productName}
        >
          <ReactMarkdown source={mdReviewText} />
        </ContentfulProductReview>
      );
    }
    default:
      break;
  }
  return null;
};

const renderHyperlink: React.FC<any> = (node: {
  data: { target: { fields: { slug: any } } };
  content: { value: any }[];
}) => {
  const { slug } = node.data.target.fields;
  const linkInner = node.content[0].value;
  return <Link to={`/${slug[lang]}/`}>{linkInner}</Link>;
};

const renderH2: React.FC<any> = (node: { content: { value: any }[] }) => {
  const { value } = node.content[0];

  const customId = customIdFromText(value);
  return <Heading2 id={customId}>{value}</Heading2>;
};

const renderStandardLink: React.FC<any> = (node: {
  data: { uri: string };
  content: { value: string }[];
}) => {
  return <OutboundLink href={node.data.uri} anchor={node.content[0].value} />;
};

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ENTRY]: renderEmbeddedEntry,
    [INLINES.ENTRY_HYPERLINK]: renderHyperlink,
    [BLOCKS.HEADING_2]: renderH2,
    [BLOCKS.EMBEDDED_ASSET]: renderAsset,
    [INLINES.HYPERLINK]: renderStandardLink,
  },
};

export { options, renderHyperlink };
